"use client";

import type { PropsWithChildren } from "react";
import { useEffect, useState } from "react";

import { IsClientContext } from "./is-client-context";

export interface IsClientProviderProps extends PropsWithChildren {}

export function IsClientProvider({ children }: IsClientProviderProps) {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line @eslint-react/hooks-extra/no-direct-set-state-in-use-effect -- that's the intended way of setting the state here
    setIsClient(true);
  }, []);

  return <IsClientContext value={isClient}>{children}</IsClientContext>;
}
